<template>
  <div v-if="operationLockStore.isLocked" class="operation-lock-overlay" @click="showToast">
    <div class="operation-lock-toast-wrapper">
      <ToastMessage :message="toastMessage" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue"
import { useOperationLockStore } from "@/stores/operationLock"
import ToastMessage from "@/components/cloud/operationLock/ToastMessage.vue"
import { useTrackingsStore } from "@/stores/trackings"

const operationLockStore = useOperationLockStore()
const trackingsStore = useTrackingsStore()

const toastMessage = ref("")
let toastTimer: ReturnType<typeof setTimeout> | null = null

const showToast = () => {
  if (toastTimer) clearTimeout(toastTimer)
  toastMessage.value = "クラ電中は操作できません"
  trackingsStore.trackKuradenEvent("operationLockToast")
  toastTimer = setTimeout(() => {
    toastMessage.value = ""
  }, 2000)
}

const blockEvent = (e: Event) => {
  e.preventDefault()
  e.stopPropagation()
}

const blockedEvents = ['keydown', 'keyup', 'keypress', 'input', 'paste'] as const

watch(() => operationLockStore.isLocked, (locked) => {
  for (const event of blockedEvents) {
    if (locked) {
      window.addEventListener(event, blockEvent, true)
    } else {
      window.removeEventListener(event, blockEvent, true)
    }
  }
  if (!locked) {
    toastMessage.value = ""
    if (toastTimer) clearTimeout(toastTimer)
  }
})
</script>

<style scoped>
.operation-lock-overlay {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9999;
  cursor: default;
}
.operation-lock-toast-wrapper :deep(.toastMessage) {
  bottom: auto;
  top: 16px;
  z-index: 10000;
}
</style>
